/**
 * @generated SignedSource<<b40d2dd64d21725d0e781d32a1edb4b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView$data = {
  readonly id?: string;
  readonly selectedOption: {
    readonly label: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView";
};
export type radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView$key = {
  readonly " $data"?: radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "selectedOption",
      "plural": false,
      "selections": [
        {
          "alias": "label",
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "type": "JiraRadioSelectField"
};

(node as any).hash = "7cda682c68e5f3dd6709f8005b44e0de";

export default node;
